import React from 'react';
import { HeroVariant14 } from '../components/HeroVariant14';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage14() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1489">
      <Navigation data-id="element-1490" />
      <main data-id="element-1491">
        <HeroVariant14 data-id="element-1492" />
        <WhyUs data-id="element-1493" />
        <Services data-id="element-1494" />
        <FAQ data-id="element-1495" />
        <Testimonials data-id="element-1496" />
        <Consultation data-id="element-1497" />
      </main>
      <Footer data-id="element-1498" />
      <CookieBanner data-id="element-1499" />
      <FloatingContact data-id="element-1500" />
    </div>;
}